/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import IncomeFilter from './IncomeFilter';
import IncomeTable from './IncomeTable';

import styles from '../remainder/styles.module.scss';
import { useAppContext } from 'providers/AppProvider';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const incomeBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'reports',
    url: '/reports/remainder'
  },

  {
    label: 'gross_income',
    active: true
  }
];

const GrossIncome = () => {
  const { t, i18n } = useTranslation();
  const {
    config: { theme }
  } = useAppContext();
  const currencyName = useSelector(
    (state: any) => state?.auth?.legal_entity?.currency?.name?.[i18n?.language]
  );
  const barcodeInputRef = useRef<HTMLInputElement>(null);

  const [generateTableData, setGeneratedTableData] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getName, setGetName] = useState('');
  const [getBarcode, setGetBarcode] = useState('');
  const [getFilterData, setGetFilterData] = useState({});
  const [selectedCurrencyName, setCurrencyName] = useState('');
  const [debouncedBarcode, setDebouncedBarcode] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalIncome, setTotalincome] = useState(0);
  const [labeledVisibleFields, setLabeledVisibleFields] = useState<any>('');

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
      setTimeout(() => barcodeInputRef.current?.select(), 500);
    }
  }, []);

  return (
    <div>
      <PageBreadcrumb items={incomeBreadcrumbItems} />
      <div>
        <div className="d-flex gap-2 align-items-center mb-5">
          <h2>{t('gross_income')}</h2>
          <ButtonRefresh
            onRefresh={() => {
              queryClient.refetchQueries('GET_REPORTS_INCOME');
            }}
          />
        </div>
        <IncomeFilter
          setGeneratedTableData={setGeneratedTableData}
          savedValues={savedValues}
          setSavedValues={setSavedValues}
          setGetName={setGetName}
          setGetBarcode={setGetBarcode}
          setGetFilterData={setGetFilterData}
          getName={getName}
          getBarcode={getBarcode}
          setCurrencyName={setCurrencyName}
          getFilterData={getFilterData}
          barcodeInputRef={barcodeInputRef}
          setDebouncedBarcode={setDebouncedBarcode}
          currentPage={currentPage}
          setPageCount={setPageCount}
          setCurrentPage={setCurrentPage}
          setTotalincome={setTotalincome}
          labeledVisibleFields={labeledVisibleFields}
        />

        <IncomeTable
          generateTableData={generateTableData}
          setGeneratedTableData={setGeneratedTableData}
          getName={getName}
          getFilterData={getFilterData}
          barcodeInputRef={barcodeInputRef}
          debouncedBarcode={debouncedBarcode}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={pageCount}
          setPageCount={setPageCount}
          getBarcode={getBarcode}
          setTotalincome={setTotalincome}
          setLabeledVisibleFields={setLabeledVisibleFields}
        />
        <div
          className={
            theme === 'dark' ? styles.darkFooterRemain : styles.footerRemain
          }
        >
          <div className={styles.box}>
            <p className="mb-0" style={{ fontWeight: '800' }}>
              {t('total_gross_income_amount')}: (
              {selectedCurrencyName !== ''
                ? selectedCurrencyName
                : currencyName}
              )
            </p>
            <span style={{ fontWeight: '800' }}>
              {totalIncome
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(totalIncome)
                    .replace(/,/g, ' ')
                : 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrossIncome;
